import { Remove } from '@mui/icons-material'
import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  Switch,
  TextareaAutosize,
  TextField,
  Typography,
  styled,
} from '@mui/material'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import useMainStore from '../../store/useMainStore'
import userInviteStore from 'store/userInviteStore'

export const Route = createFileRoute('/(partner)/_partner/invite-user')({
  component: RouteComponent,
})

const SquareButton = styled(IconButton)(() => ({
  border: '1px solid var(--Interviewer-Near-White)',
  borderRadius: '6px',
  backgroundColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '9px',
  '&:hover': {
    backgroundColor: 'var(--Light-Gray)',
  },
}))

const InvitedUserBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '8px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: 'var(--Light-Gray)',
  },
}))

const StyledTextArea = styled(TextareaAutosize)({
  backgroundColor: '#fff',
  width: '100%',
  minHeight: '135px',
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid var(--Interviewer-Lightest-Black)',
  fontFamily: 'inherit',
  fontSize: '14px',
  lineHeight: '20px',
  resize: 'vertical',
  '&:focus': {
    outline: 'none',
  },
})

export function RouteComponent() {
  // const interviewId = useMainStore.use.inviteInterviewId()
  // const deadlineISO = useMainStore.use.inviteDeadlineISO()
  // const readTime = useMainStore.use.inviteReadTime()
  // const answerTime = useMainStore.use.inviteAnswerTime()
  // const inviteEmails = useMainStore.use.inviteEmails()
  // const setInviteEmails = useMainStore.use.setInviteEmails()
  // const inviteEmailGraded = useMainStore.use.inviteEmailGraded()
  // const inviteEmailPassed = useMainStore.use.inviteEmailPassed()
  // const inviteEmailFailed = useMainStore.use.inviteEmailFailed()
  // const setInviteEmailGraded = useMainStore.use.setInviteEmailGraded()
  // const setInviteEmailPassed = useMainStore.use.setInviteEmailPassed()
  // const setInviteEmailFailed = useMainStore.use.setInviteEmailFailed()
  const resetInviteWorkflow = useMainStore.use.resetInviteWorkflow()


  // const isEmailPassedValid = inviteEmailPassed.trim().length > 0
  // const isEmailFailedValid = inviteEmailFailed.trim().length > 0
  // const isEmailGradedValid = inviteEmailGraded.trim().length > 0


   // Novooo
  const {userData, updateUserData} = userInviteStore();
  const [emailInput, setEmailInput] = useState('');
  const [invitedEmails, setInvitedEmails] = useState<string[]>([]);
  const [userPassed, setUserPassed] = useState('');
  const [userFailed, setUserFailed] = useState('');
  const [userGraded, setUserGraded] = useState('');
  const [switchOn, setSwitchOn] = useState(true);



  //Validation
  const [showValidation, setShowValidation] = useState(false)
  const isUserPassedValidation = userData.emailPassed.trim().length > 0
  const isUserFailedValidation = userData.emailFailed.trim().length > 0
  const isUserGradedValidation = userData.emailGraded.trim().length > 0
  //EndValidation

  // Fill store when some input changes
  useEffect(() => {
    updateUserData({
      emailGraded: userGraded,
      emailPassed: userPassed,
      emailFailed: userFailed,
    })
  }, [userPassed, userFailed, userGraded])

  const addEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const cleanedEmail = emailInput.trim().toLowerCase();

    if (cleanedEmail === '') return;
    if (!emailRegex.test(cleanedEmail)) {
      toast.error('Please enter a valid email address')
      return;
    }
    if (invitedEmails.includes(cleanedEmail)) {
      toast.info('This email is already invited')
      return;
    }

    const updatedEmails = [...invitedEmails, cleanedEmail];
    setInvitedEmails(updatedEmails);
    updateUserData({ emails: updatedEmails });
    setEmailInput('');
  }

  const removeEmail = (email: string) => {
    const updatedEmails = invitedEmails.filter((e) => e !== email)
    setInvitedEmails(updatedEmails)
    updateUserData({ emails: updatedEmails });
  }

  const handleToggle = (event) => {
    setSwitchOn(event.target.checked);
  }

  const inviteMutation = useMutation({
     mutationFn: async () => {
      const token = localStorage.getItem('token');
      const { interviewId, ...dataToSend } = userData;

      console.log('Dato for sendinf', dataToSend);
      
      const results = await axios.post(`https://interviewer.runasp.net/api/interviews/${interviewId}/invite-users`, dataToSend, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return results;
    },
    onSuccess: (data) => {
      toast.success('Invites sent successfully!')
    },
    onError: (error) => {
      console.log(error);
      const message = error?.response?.data?.message || error?.message || 'Unknown error'
      toast.error(`Failed to send invites: ${message}`)
    }
  })

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: {xs: '100%', md: '80%'},
        mx: 'auto',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'center'}}>
        <Typography variant="h1">Share this interview</Typography>
        <Typography>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row'}, gap: '10px', alignItems: 'center', pt: '32px', width: '100%' }}>
        <TextField
          type="text"
          label="Invite others by email"
          fullWidth
          value={emailInput}
          onChange={(e) => setEmailInput(e.target.value)}
        />
        <Button variant="contained" onClick={addEmail} sx={{ width: {xs: '100%', md: '20%'}}}>
          Invite
        </Button>
      </Box>

      <Divider sx={{ width: '100%', pt: '24px'}}/>

      <Box sx={{ width: '100%', pt: '24px'}}>
        <Typography>Sent Invites</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', pt: '8px'}}>
          {invitedEmails.map((email, index) => (
            <InvitedUserBox key={`${email}-${index}`}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <Avatar />
                  <Typography sx={{ fontWeight: '600', fontSize: '16px' }}>{email}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                  <Typography sx={{ fontSize: '14px', fontWeight: '14px', color: 'var(--Interview-Lightest-Black)' }}>
                    Candidate
                  </Typography>
                  <SquareButton onClick={() => removeEmail(email)}>
                    <Remove style={{ fontSize: 24, color: '#000' }} />
                  </SquareButton>
                </Box>
              </Box>
            </InvitedUserBox>
          ))}
        </Box>

        {invitedEmails.length > 0 && (
          <Divider sx={{ width: '100%', pt: '16px'}}/>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
          border: '1px solid var(--Light-Gray)',
          padding: '32px',
          boxShadow: '0px 1px 2px 0px #0205111A',
          borderRadius: '12px',
          width: '100%',
          mt: '24px'
        }}
      >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="h1">Inform user about the results</Typography>
              <Switch checked={switchOn} onChange={handleToggle} />
            </Box>
          {switchOn && (
            <>
              <Box sx={{ display: 'flex', flexDirection: 'column', mt: '32px' }}>
                <Box sx={{ display: 'flex', mb: '32px' }}>
                  <FormControlLabel
                    value="generic"
                    control={<Radio checked readOnly />}
                    label="Use generic messages"
                    sx={{
                      width: '100%',
                      color: '#0A0A28',
                      fontWeight: 500,
                      fontSize: '16px',
                    }}
                  />
                  <Typography sx={{ width: '100%' }}>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero dolorum beatae eius cupiditate asperiores
                    ea nemo fuga vel non architecto?
                  </Typography>
                </Box>

                <Divider>or</Divider>

                <Box sx={{ mt: '24px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <FormLabel
                      sx={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: 'var(--Interviewer-Black)',
                        mb: '2px',
                      }}
                    >
                      Email sent when user passed:
                    </FormLabel>
                    <StyledTextArea required value={userPassed} onChange={(e) => setUserPassed(e.target.value)} />
                    {showValidation && !isUserPassedValidation && (
                      <Typography sx={{ color: 'error.main', fontSize: '12px' }}>This field is required</Typography>
                    )}
                  </Box>
                </Box>
                <Box sx={{ mt: '24px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <FormLabel
                      sx={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: 'var(--Interviewer-Black)',
                        mb: '2px',
                      }}
                    >
                      Email sent when user failed:
                    </FormLabel>
                    <StyledTextArea value={userFailed} onChange={(e) => setUserFailed(e.target.value)} />
                    {showValidation && !isUserFailedValidation && (
                      <Typography sx={{ color: 'error.main', fontSize: '12px' }}>This field is required</Typography>
                    )}
                  </Box>
                </Box>
                <Box sx={{ mt: '24px' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <FormLabel
                      sx={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: 'var(--Interviewer-Black)',
                        mb: '2px',
                      }}
                    >
                      Email sent when interview is graded and awaiting decision:
                    </FormLabel>
                    <StyledTextArea value={userGraded} onChange={(e) => setUserGraded(e.target.value)} />
                    {showValidation && !isUserGradedValidation && (
                      <Typography sx={{ color: 'error.main', fontSize: '12px' }}>This field is required</Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </>
        )}
      </Box>

      <Button
        variant="contained"
        fullWidth
        sx={{ mt: '32px' }}
        onClick={() => {
          setShowValidation(true)
          if(!isUserPassedValidation || !isUserFailedValidation || !isUserGradedValidation) {
            return ;
          }
          inviteMutation.mutate()
        }}>
        Send Interview
      </Button>
    </Box>
  )
}
